<template>
  <div class="main">
    <div class="main_header">
      <!-- <div class="header_item">
        <span class="header_label">按钮名称：</span>
        <el-input v-model="buttonName" :size="size" clearable placeholder="请输入按钮名称"></el-input>
      </div> -->
      <div class="header_item">
        <!-- <el-button icon="el-icon-search"  v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button> -->
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">添加</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="buttonList"
        height="100%">
          <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="buttonHtmlId" label="按钮代码" align="center"></el-table-column>
        <el-table-column prop="buttonHtmlName" label="按钮名称" align="center"></el-table-column>
        <el-table-column prop="buttonType" label="按钮类型" align="center"></el-table-column>
        <el-table-column prop="buttonDescript" label="按钮描述" align="center"></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle ? '添加' : '修改'"
      :visible.sync="asyncVisible"
      width="35%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="按钮代码：" prop="buttonHtmlId">
          <el-input v-model="ruleForm.buttonHtmlId" :size="size" clearable placeholder="请输入按钮代码"></el-input>
        </el-form-item>
        <el-form-item label="按钮名称：" prop="buttonHtmlName">
          <el-input v-model="ruleForm.buttonHtmlName" :size="size" clearable placeholder="请输入按钮名称"></el-input>
        </el-form-item>
        <el-form-item label="按钮类型：" prop="buttonType">
          <el-select v-model="ruleForm.buttonType" :size="size" clearable placeholder="请选择按钮类型">
            <el-option
              v-for="item in buttonTypeList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="按钮描述：" prop="buttonDescript">
          <el-input v-model="ruleForm.buttonDescript" :size="size" clearable placeholder="请输入按钮描述"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()"> 提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    data() {
      return {
        size: changeSize(), // 组件尺寸
        buttonName: '', // 按钮名称
        pageNum: 1,
        pageSize: 10,
        total: 0,
        loading: false,
        buttonTypeList: [], // 按钮类型
        buttonList: [], // 按钮信息列表
        asyncTitle: true, // 对话框title 添加：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {}, // 按钮表单
        rules: {
          buttonHtmlId: [{
            required: true,
            message: '请输入按钮代码',
            trigger: 'blur'
          }],
          buttonHtmlName: [{
            required: true,
            message: '请输入按钮名称',
            trigger: 'blur'
          }],
          buttonType: [{
            required: true,
            message: '请选择按钮类型',
            trigger: 'change'
          }],
          buttonDescript: [{
            required: true,
            message: '请输入按钮描述',
            trigger: 'blur'
          }]
        }
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.getButtonTypeList();
      that.searchButtonInfo(true);
    },
    methods: {
      // 获取按钮类型
      async getButtonTypeList() {
        const { data } = await this.$api.System.getButtonType({});
        this.buttonTypeList = data;
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = {
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }
        this.loading = true;
        this.$api.System.searchButtonConfigInfo(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.buttonList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 添加按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.$set(this.ruleForm, 'buttonId', row.buttonId);
        this.$set(this.ruleForm, 'buttonHtmlId', row.buttonHtmlId);
        this.$set(this.ruleForm, 'buttonHtmlName', row.buttonHtmlName);
        this.$set(this.ruleForm, 'buttonType', row.buttonType);
        this.$set(this.ruleForm, 'buttonDescript', row.buttonDescript);
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该按钮，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.System.deleteButtonInfo({buttonId: row.buttonId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.System.insertButtonInfo(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            this.$api.System.updateButtonInfo(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>